import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModalEsqueciSenhaPage } from './modal-esqueci-senha.page';

const routes: Routes = [
  {
    path: '',
    component: ModalEsqueciSenhaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalEsqueciSenhaPageRoutingModule {}
